module.exports = __webpack_public_path__ + "static/media/Sharp-LQ150X1LX95-Mechanical-Drawing.08f5ee3e.gif";